module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_card_inactive.87a8799e.svg";